<div class="create-appoinment p-4">
  <div class="container">
    <div class="card shadow-sm p-3">
      <div class="text-center">
        <i class="fa-regular fa-circle-check fa-5x"></i>
        <h2 class="my-3">{{ "success.title" | t }}</h2>
        <h5 class="fw-normal">{{ "success.subtitle" | t }}</h5>
        <div class="warning-message">
          <p class="mb-0 text-muted">{{ "success.message1" | t }}</p>
          <p class="mb-0 text-muted">{{ "success.message2" | t }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
